// extracted by mini-css-extract-plugin
export default {"root":"CommentForm_root__pvCg9","form":"CommentForm_form__sZYKk","after":"CommentForm_after__Miib+"};